import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../shared/auth.service';

// Km page only when the company has trips on (#874). Backend /trips stays 404
// behind EnsureTripsEnabled; this only avoids rendering a dead page. Waits for the
// user like AuthGuard does; AuthGuard runs first and wins when logged out.
@Injectable({ providedIn: 'root' })
export class TripsEnabledGuard {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.user.pipe(
      filter(Boolean),
      take(1),
      map((user: any) => user.trips_enabled ? true : this.router.createUrlTree(['/registration/hours/calendar'])),
    );
  }
}
